import React from "react";
import "./index.css";
const ExtraInfo = ({
  text
}) => {
  if (!text) {
    return null;
  }
  return /*#__PURE__*/React.createElement("p", {
    className: "form__extra-info"
  }, text);
};
export default ExtraInfo;